import { render, staticRenderFns } from "./Fornecedores.vue?vue&type=template&id=5b189d41"
import script from "./Fornecedores.vue?vue&type=script&lang=js"
export * from "./Fornecedores.vue?vue&type=script&lang=js"
import style0 from "./Fornecedores.vue?vue&type=style&index=0&id=5b189d41&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports